import register from 'ShopUiBundle/modules/app/registry';
import './fancy-accordion.scss';

// tslint:disable-next-line
register('fancy-accordion', () => import(/* webpackMode: "lazy" */'./fancy-accordion'));
